import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\ListingController::upload
* @see app/Http/Controllers/ListingController.php:476
* @route '/dashboard/listings/{listing}/media'
*/
export const upload = (args: { listing: string | number | { id: string | number } } | [listing: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: upload.url(args, options),
    method: 'post',
})

upload.definition = {
    methods: ["post"],
    url: '/dashboard/listings/{listing}/media',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\ListingController::upload
* @see app/Http/Controllers/ListingController.php:476
* @route '/dashboard/listings/{listing}/media'
*/
upload.url = (args: { listing: string | number | { id: string | number } } | [listing: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { listing: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { listing: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            listing: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        listing: typeof args.listing === 'object'
        ? args.listing.id
        : args.listing,
    }

    return upload.definition.url
            .replace('{listing}', parsedArgs.listing.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ListingController::upload
* @see app/Http/Controllers/ListingController.php:476
* @route '/dashboard/listings/{listing}/media'
*/
upload.post = (args: { listing: string | number | { id: string | number } } | [listing: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: upload.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\ListingController::upload
* @see app/Http/Controllers/ListingController.php:476
* @route '/dashboard/listings/{listing}/media'
*/
const uploadForm = (args: { listing: string | number | { id: string | number } } | [listing: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: upload.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\ListingController::upload
* @see app/Http/Controllers/ListingController.php:476
* @route '/dashboard/listings/{listing}/media'
*/
uploadForm.post = (args: { listing: string | number | { id: string | number } } | [listing: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: upload.url(args, options),
    method: 'post',
})

upload.form = uploadForm

/**
* @see \App\Http\Controllers\ListingController::deleteMethod
* @see app/Http/Controllers/ListingController.php:520
* @route '/dashboard/listings/{listing}/media/{mediaId}'
*/
export const deleteMethod = (args: { listing: string | number | { id: string | number }, mediaId: string | number } | [listing: string | number | { id: string | number }, mediaId: string | number ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteMethod.url(args, options),
    method: 'delete',
})

deleteMethod.definition = {
    methods: ["delete"],
    url: '/dashboard/listings/{listing}/media/{mediaId}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\ListingController::deleteMethod
* @see app/Http/Controllers/ListingController.php:520
* @route '/dashboard/listings/{listing}/media/{mediaId}'
*/
deleteMethod.url = (args: { listing: string | number | { id: string | number }, mediaId: string | number } | [listing: string | number | { id: string | number }, mediaId: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            listing: args[0],
            mediaId: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        listing: typeof args.listing === 'object'
        ? args.listing.id
        : args.listing,
        mediaId: args.mediaId,
    }

    return deleteMethod.definition.url
            .replace('{listing}', parsedArgs.listing.toString())
            .replace('{mediaId}', parsedArgs.mediaId.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ListingController::deleteMethod
* @see app/Http/Controllers/ListingController.php:520
* @route '/dashboard/listings/{listing}/media/{mediaId}'
*/
deleteMethod.delete = (args: { listing: string | number | { id: string | number }, mediaId: string | number } | [listing: string | number | { id: string | number }, mediaId: string | number ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteMethod.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\ListingController::deleteMethod
* @see app/Http/Controllers/ListingController.php:520
* @route '/dashboard/listings/{listing}/media/{mediaId}'
*/
const deleteMethodForm = (args: { listing: string | number | { id: string | number }, mediaId: string | number } | [listing: string | number | { id: string | number }, mediaId: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: deleteMethod.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\ListingController::deleteMethod
* @see app/Http/Controllers/ListingController.php:520
* @route '/dashboard/listings/{listing}/media/{mediaId}'
*/
deleteMethodForm.delete = (args: { listing: string | number | { id: string | number }, mediaId: string | number } | [listing: string | number | { id: string | number }, mediaId: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: deleteMethod.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

deleteMethod.form = deleteMethodForm

const media = {
    upload: Object.assign(upload, upload),
    delete: Object.assign(deleteMethod, deleteMethod),
}

export default media